import { Tooltip } from "antd";
import { useState } from "react";
import { BsFilesAlt, BsFillCheckCircleFill, BsLink45Deg } from "react-icons/bs";
import "./CopyToClipboard.css";
import { useLocation } from "react-router-dom";
import { MdIosShare } from "react-icons/md";
export default function CopyToClipboard({
  textToCopy,
  buttonText = "Live Page",
  isLandingPage,
  className = "",
}: {
  textToCopy: string;
  buttonText?: string;
  isLandingPage?: boolean;
  className?: string;
}) {
  const location = useLocation();
  const [copied, setCopied] = useState(false);
  const isFollowerView = location.pathname.includes("preview");
  const showShareButton = isFollowerView || isLandingPage;
  
  const copyToClipboard = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    });
  };
  // if (isLandingPage) return null;

  return (
    <Tooltip
      placement="bottom"
      open={copied}
      title={
        <div className="tooltip-style">
          <BsFillCheckCircleFill />
          <p className="m-0">Copied!</p>
        </div>
      }
    >
      <div
        className={`${
          showShareButton
            ? "follower-share-icon copy-clipboard-btn-wrapper"
            : "copy-clipboard-btn-wrapper"
        } ${className}`}
        onClick={copyToClipboard}
      >
        {!showShareButton && <p className="m-0">{buttonText}</p>}
        {showShareButton ? (
          <>
            <MdIosShare />
            <p className="m-0">Share</p>
          </>
        ) : (
          <BsLink45Deg />
        )}
      </div>
    </Tooltip>
  );
}
